import { schema } from 'normalizr';

export const orderItemSchema = new schema.Entity('ordersItems', {}, { idAttribute: 'OrderItemId' });
export const orderItemListSchema = [orderItemSchema];

export const orderPlannerDashboardSchema = new schema.Entity('ordersPlannerDashboard', {}, { idAttribute: 'OrderId' });
export const orderPlannerDashboardListSchema = [orderPlannerDashboardSchema];
